import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import FormNotification from '../../components/forms/FormNotification';
import { ToastrContext } from '../../contexts';
import { payloadBuilder } from '../../utils/builder/notification';
import { blobToBase64 } from '../../utils/transform';
import ModalPreview from './ModalPreview';
import { createNotification } from './action';
import styles from './styles.scoped.css';
import { escapeHtml } from '../../utils/purifier';

export function AddNotification (){
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [modalNotifExample, setModalNotifExample] = useState(false);
  const [showPreviewNotification, setShowPreviewNotification] =
    useState({ isShow: false, payload: {} });
  const { addNotification } = useSelector((s) => s.notification);
  const [showError, setShowError] = useState({ isShow: false, message: '' });
  const { setToastr } = useContext(ToastrContext);


  const convertImageToBase64 = async(file) => {
    if(file.length > 0){
      const img = URL.createObjectURL(file[0]);
      const blob = await fetch(img).then((res) => res.blob());
      const base64 = await blobToBase64(blob);
      return base64;
    }
  };

  const handleSubmit = async (type, payload) => {
    if(payload.imageContent.length > 0){
      payload.imageContent = await convertImageToBase64(payload.imageContent);
    }
    if(payload.banner.length > 0){
      payload.banner = await convertImageToBase64(payload.banner);
    }
    payload.description = escapeHtml(payload.description);
    payload.title = escapeHtml(payload.title);
    const payloadBuild = payloadBuilder(payload);
    dispatch(createNotification(type, payloadBuild));
  };

  useEffect(() => {
    if(addNotification?.success){
      setToastr({
        desc: 'Notifikasi berhasil ditambahkan',
        type: 'success',
        visible: true,
      });
      navigate('/notification');
    }else if(addNotification?.message.includes('Terdapat 3 notifikasi aktif')){
      setShowError({ isShow: true, message: 'Terdapat 3 notifikasi aktif saat ini, nonaktifkan notifikasi lain untuk mengaktifkan notifikasi ini.' });
    }else{
      setToastr({
        desc: addNotification?.message,
        type: 'failed',
        visible: addNotification?.message,
      });
    }
  },[addNotification]);

  return(
    <div className={styles['form-wrapper']}>
      <FormNotification
        handleGoBack={() => navigate(-1)}
        isLoading={addNotification?.loading}
        onSubmit={handleSubmit}
        setShowError={setShowError}
        setShowPreviewNotification={setShowPreviewNotification}
        showError={showError}
        showNotificationExample={() => setModalNotifExample(true)}
      />
      <ModalPreview
        modalNotifExample={modalNotifExample}
        setModalNotifExample={setModalNotifExample}
        setShowPreviewNotification={setShowPreviewNotification}
        showPreviewNotification={showPreviewNotification} />
    </div>
  );
}

export default AddNotification;
